module.exports = __webpack_public_path__ + "media/images/BelAmi-Chambre-302f19ff5580bde500d6dbc1f4063fe0.png";